<template>
    <a-modal title="支付记录"
             :width="1100"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="confirmPassword"
             :footer="null"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-card>
            <a-table
                    :columns="columns"
                    :rowKey="record => record.id"
                    :data-source="data" bordered>

                <template slot="systemType" slot-scope="record">
                    {{record.extras.systemType === '1' ? '采购文件售价' : '报名费'}}
                </template>

                <template slot="name" slot-scope="text">
                    <a>{{ text }}</a>
                </template>

                <template slot="serialNum" slot-scope="record">
                    {{record.serialNum}}
                </template>

                <template slot="money" slot-scope="record">
                    <span class="color-red">{{record.attend_price}}</span> 元
                </template>

                <template slot="projectName" slot-scope="record">
                    {{record.extras.projectName}}
                </template>

                <template slot="packName" slot-scope="record">
                    {{record.extras.packName}}
                </template>

                <template slot="regDate" slot-scope="record">
                    {{record.extras.regDate}}
                </template>

              <template slot="qrCodePathList" slot-scope="text">
                <div v-for="(path) in text" :key="path">
                  <a target="_blank" :href="path">查看发票</a>
                </div>
              </template>
            </a-table>

        </a-card>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'

    export default {
        created() {
            this.userName = this.$store.getters.nickname
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                queryParam: {},
                id: this.$route.query.id,
                modalLoading: false,
                params: {},
                loading: false,
                account: '',
                data: [],
                columns: [
                  {
                    title: '费用类别',
                    align: 'center',
                    scopedSlots: {customRender: 'systemType'}
                  },
                  {
                    title: '项目名称',
                    align: 'center',
                    scopedSlots: {customRender: 'projectName'}
                  },
                  {
                    title: '缴纳金额',
                    align: 'center',
                    scopedSlots: {customRender: 'money'}
                  },
                    {
                        title: '流水号',
                        align: 'center',
                        scopedSlots: {customRender: 'serialNum'}
                    },
                    {
                        title: '缴纳日期',
                        align: 'center',
                        scopedSlots: {customRender: 'regDate'}
                    },
                  {
                    title: '发票',
                    align: 'center',
                    dataIndex: 'extras.qrCodePathList',
                    scopedSlots: { customRender: 'qrCodePathList' }
                  }

                ],
            }
        },
        methods: {
            initInfo() {
                let that = this
                let param = {}
                this.$http.get('/api/v1/supplier/pay/getList.json').then(function (res) {
                    that.data = res.result
                })
            },
            onSubmit() {
            },
            confirmPassword () {

            }
        }
    };
</script>
<style lang="less" scoped>
    .fx-form th{
        width: 100px;
    }
</style>
